import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { FullNameComponent } from 'src/app/shared/full-name/full-name.component';
import { RelationshipComponent } from 'src/app/shared/relationship/relationship.component';
import { PhoneNumberComponent } from 'src/app/shared/phone-number/phone-number.component';
import { ProgressBarService } from '../../core/progress-bar.service';
import { StoreService } from '../../core/store.service';
import { NavigationService } from 'src/app/core/navigation.service';
import { EmergencyContact } from './shared/emergency-contact.model';

@Component({
  selector: 'emergency-contact',
  templateUrl: './emergency-contact.component.html',
})
export class EmergencyContactComponent {
  @ViewChild(FullNameComponent) fullNameComponent: FullNameComponent;
  @ViewChild(RelationshipComponent) relationshipComponent: RelationshipComponent;
  @ViewChild(PhoneNumberComponent) phoneNumberComponent: PhoneNumberComponent;

  title = 'emergencyContact.title';
  progressBar = this.progress.emergencyContact;
  relationships: Array<string> = this.store.state.relationships;
  emergencyContact: EmergencyContact = this.store.state.consent.emergencyContact

  constructor(private router: Router,
    private progress: ProgressBarService,
    private store: StoreService,
    private navigation: NavigationService) { }

  disabled(): boolean {
    return this.fullNameComponent.form.valid &&
      this.relationshipComponent.form.valid &&
      this.phoneNumberComponent.form.valid;
  }

  back() {
    this.router.navigate([this.navigation.emergencyContact.back]);
  }

  next() {
    this.store.state.consent.emergencyContact = this.emergencyContact;
    this.store.addPotentialRepresentative(this.emergencyContact);
    this.router.navigate([this.navigation.emergencyContact.next]);
  }

}
